module.exports = __webpack_public_path__ + "static/media/adesivo_portalimoveis.e7542af2.png";